<!-- 会员中心 -->
<template>
  <div class="home">
    <h1>会员中心</h1>
    <div class="content1">
      <div class="header">
        <img :src="avatar" alt="用户头像" />
        <span>{{ tel }}</span>
      </div>
      <div class="update" @click="triggerFileInput">
        <img src="../../assets/update_icon.png" alt="" />
        <span>更新头像</span>
        <input
          type="file"
          ref="fileInput"
          style="display: none"
          accept="image/*"
          @change="handleFileChange"
        />
      </div>
      <div class="form">
        <ul>
          <li>
            <h2>公司名称</h2>
            <input v-model="company" type="text" placeholder="请输入" />
          </li>
          <li>
            <h2>联系电话</h2>
            <input v-model="tel" type="text" placeholder="请输入" disabled />
          </li>
          <li>
            <h2>邮箱</h2>
            <input v-model="email" type="text" placeholder="请输入" />
          </li>
          <li>
            <h2>QQ号</h2>
            <input v-model="qq" type="text" placeholder="请输入" />
          </li>
          <li>
            <h2>微信</h2>
            <input v-model="wechat" type="text" placeholder="请输入" />
          </li>
          <li>
            <h2>联系人</h2>
            <input v-model="contact" type="text" placeholder="请输入" />
          </li>
        </ul>
      </div>
      <div class="submit" @click="submitForm">提交</div>
    </div>
  </div>
</template>

<script>
import {
  getUserInfo,
  getUploadImage,
  getUpdateUserInfo,
} from "../../api/userApi";

export default {
  data() {
    return {
      account: "",
      avatar: localStorage.getItem("cachedAvatar"),
      company: "",
      contact: "",
      email: "",
      id: "",
      qq: "",
      tel: "",
      wechat: "",
      isSubmitting: false,
    };
  },
  async created() {
    // 获取用户信息
    await this.getUserInfo();
  },
  methods: {
    // 触发文件选择
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    // 处理文件选择
    async handleFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      try {
        // 创建FormData对象
        const formData = new FormData();
        formData.append("file", file);

        // 调用上传接口
        const response = await getUploadImage(formData);

        if (response.code === 1) {
          // 上传成功，更新头像
          this.avatar = response.data.src; // 假设接口返回图片URL
          // this.$message.success("头像上传成功");
          await this.updateAvatarOnly();
        } else {
          console.error("上传失败:", response.message);
          // 可以在这里添加错误提示
        }
      } catch (error) {
        console.error("上传出错:", error);
        // 可以在这里添加错误提示
      }

      // 重置input，以便可以重复选择同一文件
      e.target.value = "";
    },
    // 仅更新头像的方法
    async updateAvatarOnly() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      try {
        const response = await getUpdateUserInfo(
          this.avatar,
          this.company,
          this.email,
          this.qq,
          this.wechat,
          this.contact
        );

        if (response.code === 1) {
          this.$message.success("头像更新成功");
          await this.getUserInfo(); // 刷新用户信息
          window.location.reload(); // 刷新页面
          this.$emit("info-updated");
        } else {
          this.$message.error(response.message || "头像更新失败");
        }
      } catch (error) {
        console.error("更新出错:", error);
        this.$message.error(error.response?.data?.message || "更新出错");
      } finally {
        this.isSubmitting = false;
      }
    },
    async getUserInfo() {
      try {
        const response = await getUserInfo();
        console.log(response.data);
        if (response.code === 1) {
          this.account = response.data.account;
          this.avatar = response.data.avatar;
          this.company = response.data.company;
          this.contact = response.data.contact;
          this.email = response.data.email;
          this.id = response.data.id;
          this.qq = response.data.qq;
          this.tel = response.data.tel;
          this.wechat = response.data.wechat;
        }
      } catch (error) {
        console.error("获取接口失败", error);
      }
    },
    // 提交表单
    async submitForm() {
      // 检查所有必填字段是否已填写
      if (
        !this.company ||
        !this.email ||
        !this.qq ||
        !this.wechat ||
        !this.contact
      ) {
        this.$message.warning("请填写所有信息");
        return;
      }

      // 防止重复提交
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      try {
        const response = await getUpdateUserInfo(
          this.avatar,
          this.company,
          this.email,
          this.qq,
          this.wechat,
          this.contact
        );

        if (response.code === 1) {
          window.location.reload();
          this.$message.success("信息更新成功");
          await this.getUserInfo(); // 刷新用户信息
          this.$emit("info-updated");
        } else {
          this.$message.error(response.message || "信息更新失败");
        }
      } catch (error) {
        console.error("更新出错:", error);
        this.$message.error(error.response?.data?.message || "更新出错");
      }
    },
  },
};
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}
.home {
  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #434343;
    line-height: 28px;
    text-align: left;
    margin-left: 20px;
    margin-top: 20px;
  }
  .content1 {
    margin: 50px 35px;
    .header {
      display: flex;
      align-items: center;
      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-right: 20px;
      }
      span {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #434343;
        line-height: 22px;
        text-align: left;
      }
    }
    .update {
      cursor: pointer;
      width: 107px;
      height: 32px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #d9d9d9;
      display: flex;
      align-items: center;
      padding: 0 15px;
      box-sizing: border-box;
      margin-top: 24px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 3px;
      }
      span {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #262626;
      }
    }
    .form {
      ul {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        border-top: 1px solid rgba(222, 222, 222, 1);
        border-bottom: 1px solid rgba(222, 222, 222, 1);
        padding: 12px 0 32px 0;
        margin-top: 32px;
        li {
          // width: 33.3%;
          margin-top: 20px;
          margin-right: 80px;
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          // justify-content: flex-start;
          h2 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #434343;
            margin-bottom: 15px;
            // text-align: left;
          }
          input {
            width: 259px;
            height: 43px;
            background: #ffffff;
            border-radius: 4px 4px 4px 4px;
            border: none;
            outline: none;
            border: 1px solid #d8d9dc;
            padding-left: 13px;
            box-sizing: border-box;
          }
          input::placeholder {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #b1b1b1;
          }
        }
      }
    }
    .submit {
      cursor: pointer;
      width: 83px;
      height: 42px;
      background: #233cac;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      line-height: 42px;
      border-radius: 5px;
      margin-top: 185px;
    }
  }
}
</style>
